class ComplementaryPicker extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');

    this.addEventListener('change', this.onChangeHandler.bind(this));
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  onChangeHandler(event) {
    if (event.target.matches('.complementary-card__select')) {
      this.onVariantChange(event.target);
    }
  }

  onClickHandler(event) {
    const button = event.target.closest('[data-complementary-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    this.addVariant(button);
  }

  onVariantChange(select) {
    const card = select.closest('.complementary-card');
    if (!card) return;

    const option = select.options[select.selectedIndex];
    const button = card.querySelector('[data-complementary-add]');
    const priceWrapper = card.querySelector('[data-complementary-price]');

    if (button) {
      button.dataset.variantId = select.value;
    }

    if (priceWrapper) {
      const amount = priceWrapper.querySelector('.complementary-card__amount');
      const compare = priceWrapper.querySelector('.complementary-card__compare');
      const comparePrice = option.dataset.comparePrice;

      if (amount && option.dataset.price) {
        // Ueber innerHTML, damit <price-money> erst beim Einfuegen upgegradet wird
        // und seine bdi-Kinder findet.
        amount.innerHTML = `<price-money><bdi>${this.escapeHtml(option.dataset.price)}</bdi></price-money>`;
      }

      if (comparePrice) {
        if (compare) {
          compare.textContent = comparePrice;
        }
        else {
          const newCompare = document.createElement('s');
          newCompare.className = 'complementary-card__compare';
          newCompare.textContent = comparePrice;
          priceWrapper.appendChild(newCompare);
        }
      }
      else if (compare) {
        compare.remove();
      }
    }
  }

  escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[character]);
  }

  // Schnellkauf: eine Karte, eine Variante, direkt in den Warenkorb.
  addVariant(button) {
    const id = button.dataset.variantId;
    if (!id) return;

    const items = [{ id: id, quantity: 1 }];

    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
      Shopify.postLink2(theme.routes.cart_add_url, {
        parameters: {
          items: items
        }
      });
      return;
    }

    button.setAttribute('disabled', true);
    button.classList.add('loading');

    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

    const body = JSON.stringify({
      items: items,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: response.description
            }
          }));
          return;
        }

        this.miniCart && this.miniCart.renderContents(response);

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: response
          }
        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('disabled');
      });
  }
}

if (!customElements.get('complementary-picker')) {
  customElements.define('complementary-picker', ComplementaryPicker);
}
